import { useState, useEffect } from "react";
import { getSocket } from "@/lib/socket";

interface MarketItem {
  symbol: string;
  ltp: number;
  change: number;
  changePct: number;
}

const DEFAULTS: MarketItem[] = [
  { symbol: "NIFTY 50", ltp: 0, change: 0, changePct: 0 },
  { symbol: "SENSEX", ltp: 0, change: 0, changePct: 0 },
  { symbol: "BANKNIFTY", ltp: 0, change: 0, changePct: 0 },
  { symbol: "INDIA VIX", ltp: 0, change: 0, changePct: 0 },
];

export default function MarketStrip() {
  const [items, setItems] = useState<MarketItem[]>(DEFAULTS);

  useEffect(() => {
    const socket = getSocket();

    const handler = (tick: any) => {
      setItems((prev) => {
        const idx = prev.findIndex((i) => i.symbol === tick.symbol);
        if (idx >= 0) {
          const updated = [...prev];
          updated[idx] = { ...updated[idx], ...tick };
          return updated;
        }
        return prev;
      });
    };

    socket.on("market", handler);
    return () => {
      socket.off("market", handler);
    };
  }, []);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 24,
        padding: "8px 24px",
        background: "var(--surface)",
        borderBottom: "1px solid var(--border)",
        fontSize: 13,
        overflowX: "auto",
        whiteSpace: "nowrap",
      }}
    >
      {items.map((item) => {
        const positive = item.change >= 0;
        const color = item.ltp === 0 ? "var(--text-muted)" : positive ? "var(--green-light)" : "var(--red-light)";
        return (
          <div key={item.symbol} style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontWeight: 600, color: "var(--text-muted)", fontSize: 11 }}>
              {item.symbol}
            </span>
            <span style={{ fontFamily: "var(--font-mono)", fontWeight: 500 }}>
              {item.ltp > 0 ? item.ltp.toLocaleString("en-IN") : "—"}
            </span>
            {item.ltp > 0 && (
              <span style={{ fontFamily: "var(--font-mono)", fontSize: 11, color }}>
                {positive ? "+" : ""}{item.change.toFixed(2)} ({positive ? "+" : ""}{item.changePct.toFixed(2)}%)
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
